// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"cc8ae0ce","218":"9b9f4c50","225":"7862a191","347":"fc601ce0","352":"dde9ba51","380":"9201e9c3","515":"4a7ed9be","633":"28b2eda5"}[chunkId] + ".chunk.js";
};